import {
  validateFormat,
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence(true),
    validateLength({ min: 1 }),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
};
